import $ from 'jquery';
import { initTooltips } from '@/js/modules/tooltips';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function toggleSalesTaxesCallout() {
    $('.sales-taxes-callout').toggle();
    $('.p-button--new-sales-tax').toggle();
    $('.sales-taxes').toggle();
  }

  $(function () {
    if ($('body').is('#settings-sales-taxes')) {
      $(document).on('click', '.p-button--blank-sales-taxes', (e) => {
        e.preventDefault();
        toggleSalesTaxesCallout();
        $('.p-button--new-sales-tax').click();
        return false;
      });

      $(document).on($.modal.CLOSE, '.modal--sales-tax-form', () => {
        if ($('.data-table__table tbody tr').length === 0) {
          toggleSalesTaxesCallout();
        }
      });
    }
  });

  $(document).on('change', '.field--quickbooks-account', (e) => {
    const $el = $(e.target);
    const selectedText = $el.find('option:selected').text();

    $el.siblings('.map-quickbooks-accounts__account-name').val(selectedText);

    const $form = $('.map-quickbooks-accounts__form');
    $.post($form.attr('action'), $form.serialize());
  });

  $(document).on('change', '.field--quickbooks-category-mapping', (e) => {
    const $el = $(e.target);
    const itemCategoryId = $el.data().itemCategoryId;
    const quickbooksAccountId = $el.val();

    $.post(`/item_categories/${itemCategoryId}/xhr_update_quickbooks_account_id`, {
      quickbooks_account_id: quickbooksAccountId,
    });
  });

  $(document).on('change', '.green-checkbox--hide-from-client-options', (e) => {
    // UI::Switch wraps the input in its label, so the old sibling lookup finds nothing.
    const $label = $(e.target).closest('label');
    $label.addClass('opacity-50');
    $.post(
      '/settings/xhr_hide_from_client_options',
      {
        name: e.target.name,
        value: $(e.target).prop('checked'),
      },
      (_) => {
        $label.removeClass('opacity-50');
      }
    );
  });

  function togglePurchaseOrdersBillPaymentsDefaultsBlock() {
    const $parentControl = $('#quickbooks_access_convert_po_to_qbo_bill');
    const $subControls = $('.qbo-sync-settings__sub-control--po-bill-payments-defaults');

    if ($parentControl.is(':checked')) {
      $subControls.show();
    } else {
      $subControls.hide();
    }
  }

  function flipPurchaseOrdersBillPaymentsDefaultAccountMappingsFields() {
    const $parentControl = $('#quickbooks_access_convert_po_to_qbo_bill');
    const $subControls = $('.map-quickbooks-accounts__fields--po-bill-payments-defaults');
    const $dropdownWrapper = $subControls.find('.map-quickbooks-accounts-right-field');
    const $dropdown = $dropdownWrapper.find('select');
    const $label = $subControls.find('.map-quickbooks-accounts-left-field--label');

    if ($parentControl.is(':checked')) {
      $dropdown.prop('disabled', false);
      $label.css('color', '#4a5455');

      $subControls.removeClass('tooltip');
      $subControls.find('.tooltip__content').remove();

      Array.from($subControls).forEach((element) => {
        if (element._tippy) {
          element._tippy.destroy();
        }
      });
    } else {
      $dropdown.prop('disabled', true);
      $label.css('color', '#999');

      $subControls.addClass('tooltip');
      $subControls.append(
        '<div class="tooltip__content">Enable "Sync PO Payments to QBO as Bills" setting to set a default payment account.</div>'
      );

      initTooltips($subControls);
    }
  }

  function toggleRetainerLiabilityAccountMappingField() {
    if ($('input[name="quickbooks_access[retainer_sync_mode]"]').length === 0) {
      return false;
    }

    const $retainerSyncModeSetting = $(
      'input[name="quickbooks_access[retainer_sync_mode]"]:checked'
    );
    const $liabilityAccountMappingRow = $('.map-quickbooks-accounts__fields--retainer_liability');
    const $liabilityAccountDropdownWrapper = $liabilityAccountMappingRow.find(
      '.map-quickbooks-accounts-right-field'
    );
    const $dropdown = $liabilityAccountDropdownWrapper.find('select');
    const $label = $liabilityAccountMappingRow.find('.map-quickbooks-accounts-left-field--label');

    const enableLiabilityAccountMappingRow = () => {
      $dropdown.prop('disabled', false);
      $label.removeClass('map-quickbooks-accounts-left-field--label__disabled');

      $liabilityAccountMappingRow.removeClass('tooltip');
      $liabilityAccountMappingRow.find('.tooltip__content').remove();

      Array.from($liabilityAccountMappingRow).forEach((element) => {
        if (element._tippy) {
          element._tippy.destroy();
        }
      });
    };

    const disableLiabilityAccountMappingRowWithTooltip = () => {
      $dropdown.prop('disabled', true);
      $label.addClass('map-quickbooks-accounts-left-field--label__disabled');

      $liabilityAccountMappingRow.addClass('tooltip');
      $liabilityAccountMappingRow.append(
        '<div class="tooltip__content">Set "Sync Retainer Payments to QBO as:" to "Liability" to set a default liability account.</div>'
      );

      initTooltips($liabilityAccountMappingRow);
    };

    const syncRetainerAsLiabilityChoosen = $retainerSyncModeSetting.val() === '0';

    if (syncRetainerAsLiabilityChoosen) {
      enableLiabilityAccountMappingRow();
    } else {
      disableLiabilityAccountMappingRowWithTooltip();
    }
  }

  $(document).on(
    'change',
    'form.qbo-sync-settings__form input[type="checkbox"], form.qbo-sync-settings__form input[type="radio"]',
    (e) => {
      if ($(e.target).attr('id') === 'quickbooks_access_convert_po_to_qbo_bill') {
        togglePurchaseOrdersBillPaymentsDefaultsBlock();
        flipPurchaseOrdersBillPaymentsDefaultAccountMappingsFields();
      } else if ($(e.target).attr('name') === 'quickbooks_access[retainer_sync_mode]') {
        toggleRetainerLiabilityAccountMappingField();
      }

      $.rails.handleRemote($(e.target).parents('form'));
    }
  );

  $(document).ready(() => {
    togglePurchaseOrdersBillPaymentsDefaultsBlock();
    flipPurchaseOrdersBillPaymentsDefaultAccountMappingsFields();
    toggleRetainerLiabilityAccountMappingField();
  });
});
